export default "__VITE_ASSET__f5B9PuHW__"